export default __webpack_public_path__ + "static/media/login-bg-qingpi.ffebe241.png";